import { useState } from "react";

interface MaintenanceTabProps {
  values: Record<string, string>;
  onUpdate: (key: string, value: string) => void;
}

export default function MaintenanceTab({ values, onUpdate }: MaintenanceTabProps) {
  const [preview, setPreview] = useState(false);
  const enabled = values.maintenance_mode === "1" || values.maintenance_mode === "true";

  const base = "w-full rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400";

  return (
    <div className="space-y-5">
      <div className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden">
        <div className="px-5 py-4 border-b border-background-100">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-accent-100 text-accent-700">
              <i className="ri-shut-down-line"></i>
            </span>
            <div>
              <h3 className="font-heading text-base text-foreground-950">Maintenance Mode</h3>
              <p className="text-xs text-foreground-600">
                Temporarily disable the public website and show a maintenance message.
              </p>
            </div>
          </div>
        </div>
        <div className="p-5 space-y-5">
          <div className="flex items-center justify-between rounded-xl bg-background-100 border border-background-200 p-4">
            <div>
              <p className="text-sm font-semibold text-foreground-950">Enable maintenance mode</p>
              <p className="text-xs text-foreground-600">
                Only admins can access the site when this is on.
              </p>
            </div>
            <button
              type="button"
              onClick={() => onUpdate("maintenance_mode", enabled ? "0" : "1")}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                enabled ? "bg-primary-600" : "bg-background-300"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-background-50 transition-transform ${
                  enabled ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>

          <div>
            <label className="block text-xs font-semibold text-foreground-800 mb-1.5">
              Maintenance message
            </label>
            <textarea
              rows={3}
              className={`${base} resize-none`}
              value={values.maintenance_message || "We'll be back soon."}
              onChange={(e) => onUpdate("maintenance_message", e.target.value)}
              placeholder="We'll be back soon."
            />
          </div>

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => setPreview((p) => !p)}
              className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-background-300 text-foreground-800 px-4 py-2 hover:bg-background-100"
            >
              <i className="ri-eye-line"></i> {preview ? "Hide preview" : "Preview"}
            </button>
          </div>

          {preview && (
            <div className="rounded-xl bg-background-100 border border-background-200 p-8 text-center">
              <i className="ri-tools-line text-4xl text-foreground-400 mb-3"></i>
              <h4 className="text-lg font-semibold text-foreground-950 mb-1">Under Maintenance</h4>
              <p className="text-sm text-foreground-600">{values.maintenance_message || "We'll be back soon."}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}